export class Reports {
  constructor(http) {
    this.http = http;
  }

  fetchReports(
    startDate,
    endDate,
    filter_by,
    search,
  ) {

    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .post(`reports`, { startDate, endDate, filter_by, search })
      .then(response => response.data);
  }

  fetchEmptyReports() {
    return this.http.get(`reports/empty`).then(response => response.data);
  }

  fetchReportsStatuses() {
    return this.http.get('reports/status').then(response => response.data);
  }

  fetchReportsGrouping() {
    return this.http.get('reports/sort').then(response => response.data);
  }
}
